import * as React from "react"

import { cn } from "@/lib/utils"
import { useGraphite } from "@/components/Graphite"

// Graphite's field: 32px high, 13px text, the 4.6:1 input border, a 2px focus outline 2px out
const GRAPHITE_INPUT = "flex h-8 w-full rounded-md border border-input bg-transparent px-2.5 py-1 text-[13px] text-foreground transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring disabled:cursor-not-allowed disabled:opacity-40"

const Input = React.forwardRef(({ className, type, ...props }, ref) => {
  const graphite = useGraphite()
  return (
    <input
      type={type}
      className={cn(
        graphite ? GRAPHITE_INPUT : "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Input.displayName = "Input"

export { Input }
